import './App.css';
import { green, grey, purple } from '@mui/material/colors';
import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import Startup from 'pages/startup';
import AuthProvider from 'components/security/authProvider';
import PublicRoute from 'components/security/publicRoute';
import PrivateRoute from 'components/security/privateRoute';
import Dashboard from 'pages/dashboard';
import Sites from 'pages/sites';
import Users from 'pages/users';
import { theme } from 'layouts/theme';


function App({ authentReducer }: any) {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <PublicRoute path="/" component={Startup} />
        <PrivateRoute path="/Home" component={Dashboard} />
        {/* <PrivateRoute path="/Sites" component={Sites} /> */}
        <PrivateRoute path="/Users" component={Users} />
      </AuthProvider>
    </ThemeProvider>
  );
}


export default App;
